module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"from":"від","project":"проєкт","hour":"год","services":"{n} послуг | {n} послуга | {n} послуги | {n} послуг"},"en":{"from":"from","project":"project","hour":"hour","services":"{n} services | {n} service | {n} services"}}')
  delete Component.options._Ctor
}
